export default __webpack_public_path__ + "static/media/video place holder 1.02af0a6d.svg";